import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { getImageUrl } from 'utils/assets/Cdn'

export const Subtitle = styled.span`
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.medium};
`

export const ReadingDataGraphImage = styled.img.attrs({
  src: getImageUrl('admin/reading-data-graph.png')
})`
  margin: ${tokens.spacing.verticalXlarge} 0;
  width: 100%;
  height: auto;
`

export const AccordionWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const AccordionText = styled.span`
  color: ${tokens.colors.dark6};
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.medium};
  margin-left: ${tokens.spacing.horizontalXxsmall};
`

export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.insetXsmall};
  margin-left: -${tokens.spacing.horizontalMedium};
`

export const MapGoalInformationWrapper = styled.div<{ color: string }>`
  ${({ color }) => `background-color: ${color};`}
  border-radius: ${tokens.radius.large};
  padding: ${tokens.spacing.insetMedium};
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.insetXsmall};
  text-align: left;
`

export const MapGoalTitle = styled.span<{ color: string }>`
  ${({ color }) => `color: ${color};`}
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
`

export const MapGoalText = styled.span`
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.small};
`
